module.exports = __webpack_public_path__ + "img/1.77214ec2.png";